module.exports = __webpack_public_path__ + "static/media/3.39772731.png";